import { ICONS } from '@client/constants/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/compliance/incidents')({
    staticData: {
        metadata: {
            title: 'Incidents',
        },
        roles: ['user', 'shared_edit_user', 'org_admin'],
        ui: {
            icon: ICONS.incident,
        },
    },
    component: Outlet,
});
